import { useWoodprices } from "../context/Woodprices";

import Skeleton from "../../comps/Skeleton";
import { Text } from "@ui-component-library";

import Caret from '@assets/icons/caret-right.svg';
import Retry from "../../comps/RetryBlock";

export default function Posts({ onPostSelect }) {
  const { posts, fetchNews } = useWoodprices();
  
  const handlePostClick = (post) => {
    if (!post.id) {
      console.error('Post has no ID.');
      return;
    }
    if (onPostSelect) {
      onPostSelect(post);
    }
  };

  if(posts === null) {
    return <Retry func={fetchNews} />
  } else if (posts.length === 0) {
    return Array.from({ length: 3 }, (_) => {
      return <div className="flex flex-col gap-2 px-4 py-2 max-w-full">
        <Skeleton className="h-4 w-[40%] h-[16px]" />
        <Skeleton className="w-[60%] h-[16px]" />
        <Skeleton className="w-full h-[32px]" />
        <Skeleton className="w-[20%] h-[16px]" />
      </div>
    })
  } else {
    return (
      <>
        <div className="flex flex-col px-4">
          {posts?.map((post, index) => {
            const date = new Date(post.published_date)
            const formattedDate = date.toLocaleDateString('sv-SE', {day: 'numeric', month: 'short'})
            return <div 
              key={index}
              onClick={() => handlePostClick(post)}
              className={`py-2 cursor-pointer ${(index+1) != posts.length ? 'border-b-1 border-[#E6E6E6]' : ''}`}
            >
              <div className='flex flex-col justify-between gap-2 w-full max-w-full'>
                <Text className='line-clamp-1 text-[#737373]' variant='text-2xs/leading-normal/normal'>{formattedDate} • {post.category_name}</Text>
                <Text className='line-clamp-1 text-[#0F0F0F]' variant='text-sm/leading-normal/normal'>{post.title}</Text>
                <Text className='line-clamp-2 text-[#737373]' variant='text-xs/leading-normal/normal'>{post.description}</Text>

                <div className='flex justify-between items-center'>
                  <Text className='line-clamp-1 text-[#737373]' variant='text-xs/leading-normal/normal'>{post.author}</Text>
                  <Caret fill='#0F0F0F' width='16px' height='16px' />
                </div>
              </div>
            </div>
          })}
        </div>
      </>
    );
  }
}